// src/components/HiDPIBlocker.js
import React from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@material-ui/core';
import useHiDPI from '../hooks/useHiDPI';

const IGNORE_SESSION_KEY = 'pixelcrm.hidpi-check-ignored';

export default function HiDPIBlocker({ threshold = 1.25 }) {
    const [isIgnored, setIsIgnored] = React.useState(() => {
        if (typeof window === 'undefined') return false;
        try {
            return window.sessionStorage.getItem(IGNORE_SESSION_KEY) === '1';
        } catch (e) {
            return false;
        }
    });
    const isHiDPI = useHiDPI(threshold, !isIgnored);

    // mobile исключаем — там dpr всегда > 2
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

    if (!isHiDPI || isMobile) return null;

    const handleReload = () => window.location.reload();
    const handleIgnore = () => {
        try {
            window.sessionStorage.setItem(IGNORE_SESSION_KEY, '1');
        } catch (e) {}
        setIsIgnored(true);
    };

    return (
        <Dialog
            open
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="hidpi-warning-title"
        >
            <DialogTitle id="hidpi-warning-title">
                Неподдерживаемый масштаб интерфейса
            </DialogTitle>

            <DialogContent>
                <Typography variant="body2" component="p" gutterBottom>
                    Обнаружено системное или браузерное увеличение &gt; 125 %.
                    Это может «сломать» отображение CRM — часть элементов выйдет
                    за пределы экрана.
                </Typography>

                <Typography variant="body2" component="p" gutterBottom>
                    Пожалуйста, верните масштаб к 100 % и обновите страницу.
                </Typography>

            </DialogContent>

            <DialogActions>
                <Button onClick={handleIgnore} color="default">
                    Игнорировать
                </Button>
                <Button variant="contained" color="primary" onClick={handleReload}>
                    Исправил — перезапустить
                </Button>
            </DialogActions>
        </Dialog>
    );
}

HiDPIBlocker.propTypes = {
    threshold: PropTypes.number,
};
